import { ExclamationMark } from '@phosphor-icons/react/dist/ssr'
import { twMerge } from 'tailwind-merge'

import LinkItem from '~@Atoms/link-item/link-item'

import { IButtonAlert } from '~@Types/components/IButtonAlert'

export const ButtonAlert = ({
  ariaLabel,
  isAlternate = false,
  className,
  children,
  ...linkProps
}: IButtonAlert) => {
  return (
    <LinkItem
      {...linkProps}
      className={twMerge(
        `ButtonAlert group cursor-pointer inline-flex items-center gap-x-2xs rounded-full border-[1px] typeface-caption1-standard border-solid ${isAlternate ? 'border-white-white text-white-white hover:bg-white-white hover:text-brand-secondary' : 'border-grey-dark text-grey-dark hover:bg-grey-grey hover:text-white-white'} transition-all duration-300 ease-in-out py-3xs pl-xs pr-2xs`,
        className
      )}
    >
      {children && (
        <span className="flex items-center gap-2xs">{children}</span>
      )}
      <ExclamationMark
        className="text-brand-secondary rounded-full border-solid border-brand-secondary border-[2px]"
        size={16}
        weight="bold"
        role="img"
        {...(ariaLabel && { 'aria-label': ariaLabel })}
      />
    </LinkItem>
  )
}

export default ButtonAlert
